// Platform-admin "Clear sign-in lockout" helpers (SEC-32 follow-up). Pure
// module so the input and error mapping are unit-testable.

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Trimmed, lower-cased email, or null when it can't be an email address. */
export function normalizeLockoutEmail(raw: string): string | null {
  const email = (raw || '').trim().toLowerCase();
  if (!email || email.length > 320 || !EMAIL_PATTERN.test(email)) return null;
  return email;
}

/** i18n key for a failed clear request, by HTTP status. */
export function otpLockoutClearErrorKey(status?: number): string {
  if (status === 400 || status === 422) return 'platformAdmin.otpLockout.invalidEmail';
  if (status === 403) return 'platformAdmin.otpLockout.forbidden';
  return 'platformAdmin.otpLockout.error';
}
